import { axiosGet } from '../ServiceBase.js';

const DEBUG = process.env.REACT_APP_ENV !== 'production' || localStorage.getItem('DEBUG_WS') === 'true';

const log = (label, data) => {
  if (DEBUG) {
    console.log(`[WebSocket] ${label}`, data);
  }
};

const error = (label, data) => {
  if (DEBUG) {
    console.error(`[WebSocket] ❌ ${label}`, data);
  }
};

/**
 * Envía un mensaje por websocket a mi-consultorio
 * @param {string} token
 * @returns
 */
export const sendMessageOrdenCancelada = async (token) => {
  log('sendMessageOrdenCancelada', { token });
  try {
    const res = await axiosGet(`/v1/websocket-ordenes/send-cancelada?token=${token}`);
    log('sendMessageOrdenCancelada - SUCCESS', res);
    return true;
  } catch (err) {
    error('sendMessageOrdenCancelada - FAILED', err);
    throw err;
  }
};

/**
 * Crea una conexión WebSocket al servidor
 * @param {string} tokenQr - Token del QR escaneado
 * @returns {WebSocket} instancia del WebSocket conectado
 */
export const createWebSocketConnection = (tokenQr) => {
  const wsUrl = process.env.REACT_APP_WEBSOCKET_URL;
  const jwtToken = localStorage.getItem('token');
  const fullUrl = `${wsUrl}?tokenQr=${tokenQr}&token=${jwtToken}`;

  log('createWebSocketConnection', {
    wsUrl,
    tokenQr: tokenQr?.substring(0, 20) + '...',
    fullUrl: fullUrl?.substring(0, 50) + '...',
  });

  const socket = new WebSocket(fullUrl);

  // Event listeners para debug
  socket.onopen = () => {
    log('WebSocket ABIERTO ✅', {
      readyState: socket.readyState,
      url: socket.url?.substring(0, 50) + '...',
      timestamp: new Date().toISOString(),
    });
  };

  socket.onmessage = (event) => {
    try {
      const message = JSON.parse(event.data);
      log('WebSocket MENSAJE RECIBIDO ✅', {
        state: message.state || message.State,
        hasData: !!message.data,
        timestamp: new Date().toISOString(),
        fullMessage: message,
      });
    } catch (e) {
      error('WebSocket - Error al parsear mensaje', event.data);
    }
  };

  socket.onerror = (event) => {
    error('WebSocket ERROR', {
      readyState: socket.readyState,
      event,
      timestamp: new Date().toISOString(),
    });
  };

  socket.onclose = (event) => {
    log('WebSocket CERRADO', {
      code: event.code,
      reason: event.reason,
      wasClean: event.wasClean,
      timestamp: new Date().toISOString(),
    });
  };

  return socket;
};

/**
 * Envía un mensaje JSON por una conexión WebSocket abierta
 * @param {WebSocket} socket
 * @param {object} message
 */
export const sendWebSocketMessage = (socket, message) => {
  if (socket && socket.readyState === WebSocket.OPEN) {
    log('sendWebSocketMessage', {
      messageType: message.type,
      readyState: socket.readyState,
      message,
    });
    socket.send(JSON.stringify(message));
  } else {
    error('sendWebSocketMessage - Socket no está abierto', {
      readyState: socket?.readyState,
      isConnected: socket?.readyState === WebSocket.OPEN,
    });
  }
};
